export default __webpack_public_path__ + "images/01f47bac64e261c4896ed3c1310e14c6.png";